export default "__VITE_ASSET__41355e36__"